import { useAsync } from '@platform/ui';
import { api, type BookingRequest } from '../api';

/** Booking requests of resources the user approves (empty for users who are no delegate, also on errors). */
export function useBookingRequests(key: number) {
  return useAsync(() => api.bookingRequests().catch(() => [] as BookingRequest[]), key);
}
